export const privacyPolicy = "*Due to Privacy Policy and signed NDA, cannot provide link to the production or development application.";
export const nameError = "Invalid name! Name can be alphanumeric but cannot be empty";
export const emailError = "Invalid email! Email can be alphanumeric but cannot be empty";
export const messageError = "You cannot send an empty message!";
export const nameFieldPlaceholder = 'Tell me who you are, bruh!!';
export const emailFieldPlaceholder = 'How can I reach you back';
export const messageFieldPlaceholder = 'You wanna say something to me, or you just chillin..!!';